import api from './api';

export const getMyInvoicePreview = async () => {
  const response = await api.get('/billing/my-invoice-preview');
  return response.data;
};
